import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'themes',
    collectionActionName: 'APM_THEMES',
    itemActionName: 'APM_THEME',
});
